/**
 * streamlines add a dynamic value to marginLeft.
 * @param {object} param0
 * @param {number|string} param0.$marginLeft
 * @returns {string}
 */
const dynMarginLeft = ({ $marginLeft }) => {
  if ($marginLeft === undefined) return "";
  if (typeof $marginLeft === "number") return `margin-left: ${$marginLeft}px;`;
  return `margin-left: ${$marginLeft};`;
};

export default dynMarginLeft;
